jQuery(document).ready(function ($) {
    $('.js-next-section').on('click', function (event) {
        const parentSection = $(this).parents('section').get(0);
        const nextSection = $(parentSection).next();

        $('html, body').animate({
            scrollTop: $(nextSection).offset().top - $('.site-header').outerHeight()
        }, 1000);
    });
});